import Document from "./Document";
import BaseModel from "./BaseModel";

export default class DocumentFolder extends BaseModel {

	static entity = 'document_folders';
	static route = 'document-folders';
	static plural = 'document_folders';
	static singular = 'document_folder';

	static fields () {
		return {
			id: this.attr(null),
			parent_folder_id: this.attr(null),
			parent_folder: this.belongsTo(DocumentFolder, 'parent_folder_id'),
			name: this.attr(null),
			icon: this.attr(null),
			private: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),
			documents: this.hasMany(Document, 'document_folder_id', 'id'),
		}
	}

	// static apiConfig = {
	// 	actions: {
	// 		fetch(params) {
	// 			return this.get('/'+DocumentFolder.route, {
	// 				params: params,
	// 				dataTransformer: (response) => {
	// 					if(response.status === 200 && response.data.data[DocumentFolder.entity]) {
	// 						return response.data.data[DocumentFolder.entity];
	// 					} else {
	// 						return [];
	// 					}
	// 				}
	// 			});
	// 		}
	// 	}
	// }

}
